
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalStatic as ObiThreewayDigitalStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-static.js';
 
 
 

 
 export const ObiThreewayDigitalStatic = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-static',
   elementClass: ObiThreewayDigitalStaticElement,
   events: {
     
   }
  });
 
 